// calendar-2 (Carla's round-5 decision, 2026-10-12): the pushes a calendar did not take, as
// GET /api/tasks answers them (calendarSyncErrors: [{ taskId, provider, label, error, at,
// occurrenceStart }], the caller's own calendars only). Kept here, outside the task list, so the
// list's own "nothing changed" check (App.js compares ids and updatedAt) cannot hide a new mark, and
// so the task detail (components/task/CalendarSyncNotice.jsx) reads them wherever it is opened.
import { useSyncExternalStore } from 'react';

let marks = [];
const listeners = new Set();

/** Replace the marks with a list answer's. undefined (the field left out: not read) keeps them. */
export function setCalendarSyncErrors(list) {
  if (!Array.isArray(list)) return;
  marks = list.filter((m) => m && m.taskId !== undefined && m.taskId !== null);
  listeners.forEach((l) => l());
}

/** Replace one task's marks with what the server read back for it (Retry's answer). */
export function replaceCalendarSyncErrorsForTask(taskId, list) {
  if (!Array.isArray(list)) return;
  const id = String(taskId);
  setCalendarSyncErrors([...marks.filter((m) => String(m.taskId) !== id), ...list]);
}

export function calendarSyncErrorsForTask(taskId) {
  const id = String(taskId);
  return marks.filter((m) => String(m.taskId) === id);
}

function subscribe(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** A task's marks, re-rendering when they change. */
export function useCalendarSyncErrors(taskId) {
  const all = useSyncExternalStore(subscribe, () => marks, () => marks);
  const id = String(taskId);
  return all.filter((m) => String(m.taskId) === id);
}
